import { render, staticRenderFns } from "./EmailVerificationDialog.vue?vue&type=template&id=5067bb40&scoped=true"
import script from "./EmailVerificationDialog.vue?vue&type=script&lang=js"
export * from "./EmailVerificationDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationDialog.vue?vue&type=style&index=0&id=5067bb40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5067bb40",
  null
  
)

export default component.exports